import React from 'react';

import { useIntl } from 'react-intl';

import { Cell } from '../Cell/Cell';
import { UI_TABLE_SELECT_CELL_TESTID } from '../constants';

function SelectCell({
  dispatch,
  getToggleAllPageRowsSelectedProps,
  row,
  rows,
  state,
}) {
  const intl = useIntl();
  const isHeader = !row;

  const { isMultiSelectRows, name, primaryColumnKey, trackedSelectedRowIndex } =
    state;

  const { checked, indeterminate, onChange } = isHeader
    ? getToggleAllPageRowsSelectedProps()
    : row.getToggleRowSelectedProps();
  const value = indeterminate ? null : checked;

  const handleChange = (updatedValue) => {
    const dummyEvent = { target: { value: updatedValue } };
    onChange(dummyEvent);

    if (row) {
      dispatch({
        type: 'trackSelectedRow',
        payload: row.index,
      });
    }
  };

  /**
   * This handler implements the logic of multi-selection when shift-clicking:
   * - Read the tracked state.lastSelectedRowIndex
   * - Create a sorted (ascending) index tuple i.e. [start, large].  The ascending sorting is actually a behavior of the feature when shift-selecting.
   * - Get the selectedRowIds from the rows using the start and end index.
   * - Dispatch an action to handle and set the state in Redux.
   */
  const handleShiftClick = () => {
    if (row) {
      const [startIndex, endIndex] = [
        trackedSelectedRowIndex,
        row.index,
      ].sort();
      const rowIds = rows.slice(startIndex, endIndex + 1).map((row) => row.id);

      dispatch({
        type: 'toggleMultipleRowsSelected',
        payload: rowIds,
      });
    }
  };

  return (
    <Cell
      align="center"
      as={isHeader ? 'th' : 'td'}
      cellProps={{
        label: isHeader
          ? intl.formatMessage({
              id: 'Table.selectCell.selectAllRows',
              defaultMessage: 'select all rows',
              description: 'Label for the select all rows checkbox',
            })
          : row.original[primaryColumnKey]
            ? intl.formatMessage(
                {
                  id: 'Table.selectCell.selectRowOriginal',
                  defaultMessage: 'select row {rowOriginal}',
                  description:
                    'Label for the select row checkbox. Example: rowOriginal = "John Smith"',
                },
                {
                  rowOriginal: row.original[primaryColumnKey],
                },
              )
            : intl.formatMessage(
                {
                  id: 'Table.selectCell.selectRow',
                  defaultMessage: 'select row {row}',
                  description:
                    'Label for the select row checkbox. Example: row = "row-123"',
                },
                {
                  row: row.id,
                },
              ),
        name,
        value,
        onChange: handleChange,
        onShiftClick: isMultiSelectRows ? handleShiftClick : undefined,
      }}
      className={UI_TABLE_SELECT_CELL_TESTID}
      stickyLeft={0}
      type={isMultiSelectRows ? 'checkbox' : 'radio'}
    />
  );
}

export default SelectCell;
